module.exports = __webpack_public_path__ + "static/media/csvFileExtension.b660e0e6.svg";